export const SUPPORTED_COUNTRY_CODES = ['US', 'CA'];

export const DEFAULT_DOMESTIC_COUNTRY_CODE = 'US';

export const DEFAULT_DOMESTIC_CURRENCY = 'USD';

export const SUPPORTED_LANGUAGE = ['en', 'fr'];

export const SUPPORTED_LOCALES = ['en-US', 'en-CA', 'fr-CA'];

export const SUPPORTED_CURRENCIES = ['USD', 'CAD'];

export const UNITS_MEASUREMENT = ['IMPERIAL', 'METRIC'];

export const DEFAULT_UNIT_MEASUREMENT = 'IMPERIAL';
